


























import { Vue, Component, Prop, Watch, Emit } from "vue-property-decorator";
import { NotificationEventBus } from "@/EventBus";
import { Auth, Logger } from 'aws-amplify';

// Logger.LOG_LEVEL = "DEBUG";
const logger = new Logger("StepSlider.vue");

@Component({
    // Need this empty components object for the Amplify Logger
    components: {
    },
})

export default class StepSlider extends Vue {

    @Prop({
        default: 5,
        type: Number,
    })
    steps!: number;

    //@Prop({
    //    default: null,
    //    type: Number,
    //})
    //value!: number | null;

    @Emit('changed-step')
    private changeStep(value: any) {
        return value/this.steps;
    }

}

